// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2a0O3","label":"CategoryService_label__3DS_9","location":"CategoryService_location__3PsxZ"};